import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Grid,
  Autocomplete,
  FormControlLabel,
  Checkbox,
  Chip,
} from "@mui/material";
import { SaveOrEditQuestionnariesMapping, getQuestionnaireNames } from "../../Service/AxiosService";

const AddQuestionnaire = (props: {
  open: boolean;
  onClose: () => void;
  TagList: any[];
  initialvalues?: any;
  cerboTags: any[];
  customFields?: { fieldId: string; fieldName: string }[];
  tagListForNotes?: any[];
}): React.ReactElement => {
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [QuestionnaryText, setQuestionnaryText] = useState<string>("");
  // Names already seen on charts in this clinic; a new form shows up the first time it is assigned to anyone.
  const [questionnaireNames, setQuestionnaireNames] = useState<string[]>([]);
  useEffect(() => {
    if (!props.open) return;
    (async () => {
      const res = await getQuestionnaireNames();
      setQuestionnaireNames(res.success && Array.isArray(res.data) ? res.data : []);
    })();
  }, [props.open]);
  const [enableSave, setEnableSave] = useState(false);
  const [enableTagCondition, setEnableTagCondition] = useState(false);
  const [conditionerboTagIds, setConditionerboTagIds] = useState<string[]>([]);
  const [AddCrmTagIds, setAddCrmTagIds] = useState<string[]>([]);
  const [RemoveCrmTagIds, setRemoveCrmTagIds] = useState<string[]>([]);
  const [AddcerboTagIds, setAddcerboTagIds] = useState<string[]>([]);
  const [RemovecerboTagIds, setRemovecerboTagIds] = useState<string[]>([]);
  const [customFieldId, setCustomFieldId] = useState<string>("");
  const [customFieldValue, setCustomFieldValue] = useState<string>("");
  const [cerboNotesTagId, setCerboNotesTagId] = useState<string>("");
  const [cerboTagNotes, setCerboTagNotes] = useState<string>("");

  const handleCancel = () => {
    setError(null);
    props.onClose();
  };

  const handleSubmit = async () => {
    setSaving(true);
    setError(null);
    await SaveOrEditQuestionnariesMapping({
      id: props.initialvalues ? props.initialvalues.id : undefined,
      questionnaryText: QuestionnaryText,
      enableTagCondition: enableTagCondition,
      conditionTags:
        conditionerboTagIds.length > 0 ? conditionerboTagIds.join(",") : null,
      cerboAddTags: AddcerboTagIds.length > 0 ? AddcerboTagIds.join(",") : null,
      cerboRemoveTags:
        RemovecerboTagIds.length > 0 ? RemovecerboTagIds.join(",") : null,
      crmAddTags: AddCrmTagIds.length > 0 ? AddCrmTagIds.join(",") : null,
      crmRemoveTags:
        RemoveCrmTagIds.length > 0 ? RemoveCrmTagIds.join(",") : null,
      customFieldId: customFieldId || null,
      customFieldValue: customFieldValue || null,
      cerboNotesTagId: cerboNotesTagId || null,
      cerboTagNotes: cerboTagNotes || null,
    });
    try {
      setSaving(false);
      handleCancel();
    } catch (err) {
      setSaving(false);
      setError("Failed to save. Please try again.");
    }
  };

  useEffect(() => {
    if (props.initialvalues) {
      console.log('Initial values received:', props.initialvalues);
      setQuestionnaryText(props.initialvalues.questionnaireDetails);
      setEnableTagCondition(
        props.initialvalues.enableTag == "Enabled" ? true : false,
      );
      setConditionerboTagIds(
        props.initialvalues.conditionTagIds
          ? props.initialvalues.conditionTagIds.split(',')
          : [],
      );
      setAddcerboTagIds(
        props.initialvalues.cerboAddTagIds
          ? props.initialvalues.cerboAddTagIds.split(',')
          : [],
      );
      setRemovecerboTagIds(
        props.initialvalues.cerboRemoveTagIds
          ? props.initialvalues.cerboRemoveTagIds.split(',')
          : [],
      );
      setAddCrmTagIds(
        props.initialvalues.crmAddTagIds
          ? props.initialvalues.crmAddTagIds.split(',')
          : [],
      );
      setRemoveCrmTagIds(
        props.initialvalues.crmRemoveTagIds
          ? props.initialvalues.crmRemoveTagIds.split(',')
          : [],
      );
      console.log('Setting customFieldId:', props.initialvalues.CustomFieldId);
      console.log('Setting customFieldValue:', props.initialvalues.CustomFieldValueNew);
      console.log('Setting cerboNotesTagId:', props.initialvalues.cerboNotesTagId);
      console.log('Setting cerboTagNotes:', props.initialvalues.CerboTagNotes);
      setCustomFieldId(props.initialvalues.CustomFieldId || "");
      setCustomFieldValue(props.initialvalues.CustomFieldValueNew || "");
      setCerboNotesTagId(props.initialvalues.cerboNotesTagId || "");
      setCerboTagNotes(props.initialvalues.CerboTagNotes || "");
    } else {
      setQuestionnaryText("");
      setEnableTagCondition(false);
      setConditionerboTagIds([]);
      setAddcerboTagIds([]);
      setRemovecerboTagIds([]);
      setAddCrmTagIds([]);
      setRemoveCrmTagIds([]);
      setCustomFieldId("");
      setCustomFieldValue("");
      setCerboNotesTagId("");
      setCerboTagNotes("");
    }
  }, []);

  useEffect(() => {
    if (
      QuestionnaryText != "" &&
      (AddCrmTagIds.length > 0 ||
        RemoveCrmTagIds.length > 0 ||
        AddcerboTagIds.length > 0 ||
        RemovecerboTagIds.length > 0)
    ) {
      if (enableTagCondition) {
        if (conditionerboTagIds.length > 0) {
          setEnableSave(true);
        } else {
          setEnableSave(false);
        }
      } else {
        setEnableSave(true);
      }
    } else {
      setEnableSave(false);
    }
  }, [
    AddCrmTagIds,
    RemoveCrmTagIds,
    AddcerboTagIds,
    RemovecerboTagIds,
    conditionerboTagIds,
    QuestionnaryText,
    enableTagCondition,
  ]);

  return (
    <Dialog
      open={props.open}
      onClose={props.onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          background: "#FAFAFC",
          boxShadow: "0 2px 16px rgba(24,26,42,0.10)",
          minWidth: 390,
        },
      }}
    >
      <DialogTitle sx={{ fontWeight: 700 }}>Configure Questionnaire Rule</DialogTitle>
      <DialogContent
        dividers
        sx={{
          display: "flex",
          flexDirection: "column",
          p: { xs: 2, sm: 3 },
          maxHeight: "80vh",
          overflowY: "auto",
          minHeight: 0,
          background: "#FAFAFC",
        }}
      >
        <Box sx={{ width: "100%" }}>
          {/* Step 1: GHL Tag Name */}
          <Box sx={{ display: "flex", gap: 1, position: "relative" }}>
            <Box className="step-number">1</Box>
            <Box
              sx={{
                position: "absolute",
                left: 19,
                top: 38,
                bottom: 0,
                width: 2,
                bgcolor: "#e2e8f0",
              }}
            />
            <Box sx={{ width: "100%" }}>
              <Box
                sx={{
                  bgcolor: "#f3f9ff",
                  px: 2,
                  py: 1,
                  borderRadius: 4,
                }}
              >
                <Typography
                  variant="subtitle1"
                  sx={{ fontWeight: 600, fontSize: 14 }}
                >
                  Questionnaire Name
                </Typography>
                <Typography sx={{ fontSize: 11, color: "#555" }}>
                  Enter a name for this questionnaire.
                </Typography>
              </Box>

              <Grid
                container
                spacing={2}
                direction="column"
                sx={{ mt: 3, mb: 4, ml: 3 }}
              >
                <Grid>
                  <Autocomplete
                    freeSolo
                    options={questionnaireNames}
                    value={QuestionnaryText}
                    inputValue={QuestionnaryText}
                    onInputChange={(_, v) => setQuestionnaryText(v ?? "")}
                    onChange={(_, v) => setQuestionnaryText(typeof v === "string" ? v : v ?? "")}
                    fullWidth
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Questionnaire Name"
                        helperText={questionnaireNames.length > 0
                          ? `Pick from the ${questionnaireNames.length} questionnaire names seen on charts, or type one`
                          : "No questionnaire names seen on charts yet; type the exact Cerbo name"}
                        sx={{
                      width: "100%",
                      bgcolor: "#fff",
                      borderRadius: 2,
                      boxShadow: "0 2px 8px rgba(24,26,42,0.08)",
                      "& .MuiOutlinedInput-root": {
                        fontSize: 14,
                        color: "#23244A",
                        borderRadius: 2,
                        "& fieldset": {
                          borderColor: "#dedede",
                        },
                        "&:hover fieldset": {
                          borderColor: "#3D52A0",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: "#3D52A0",
                        },
                      },

                      "& .MuiInputLabel-root": {
                        fontSize: 13,
                        color: "#23244A",
                      },
                    }}

                      />
                    )}
                  />
                </Grid>
              </Grid>
            </Box>
          </Box>

          <Box sx={{ display: "flex", gap: 1, position: "relative" }}>
            <Box className="step-number">2</Box>
            <Box
              sx={{
                position: "absolute",
                left: 19,
                top: 38,
                bottom: 0,
                width: 2,
                bgcolor: "#e2e8f0",
              }}
            />
            <Box sx={{ width: "100%" }}>
              <Box
                sx={{
                  bgcolor: "#f3f9ff",
                  px: 2,
                  py: 1,
                  borderRadius: 4,
                }}
              >
                <Grid direction='row' container alignItems="center" gap={0.5}>
                  <Typography
                    variant="subtitle1"
                    sx={{ fontWeight: 600, fontSize: 14 }}
                  >
                    Tag Condition
                  </Typography>
                  <Typography
                    variant="subtitle1"
                    sx={{ fontWeight: 600, fontSize: 13, color: "#555" }}
                  >
                    (Optional)
                  </Typography>
                </Grid>
                <Typography sx={{ fontSize: 11, color: "#555" }}>
                  Enable and select tags to further restrict when this rule applies.
                </Typography>
              </Box>

              <Grid
                container
                spacing={2}
                direction="column"
                sx={{ mt: 2, mb: 4, ml: 3 }}
              >
                <Grid>
                  <FormControlLabel
                    sx={{
                      "& .MuiFormControlLabel-label": {
                        fontSize: 13,
                        color: "#475569",
                      },
                    }}
                    control={
                      <Checkbox
                        checked={enableTagCondition}
                        style={{ marginRight: 2 }}
                        onChange={(e) =>
                          setEnableTagCondition(e.target.checked)
                        }
                        sx={{
                          "& .MuiSvgIcon-root": {
                            fontSize: 18,
                          },
                          color: "#94a3b8",
                        }}
                      />
                    }
                    label="Enable Tag Condition"
                  />
                </Grid>
                {enableTagCondition && (
                  <>
                    <Grid>
                      <Autocomplete
                        multiple
                        fullWidth
                        disableCloseOnSelect
                        limitTags={2} // Show up to 2 tags, then "+N"
                        options={props.cerboTags}
                        getOptionLabel={(option) => option.name}
                        slotProps={{
                          paper: {
                            sx: {
                              "& .MuiAutocomplete-option": {
                                fontSize: 13,
                                minHeight: 32,
                              },
                            },
                          },
                        }}
                        value={
                          props.cerboTags.filter((tag) =>
                            conditionerboTagIds.includes(tag.id),
                          ) || []
                        }
                        onChange={(_, newValue) => {
                          setConditionerboTagIds(
                            newValue ? newValue.map((tag) => tag.id) : [],
                          );
                        }}
                        renderOption={(props, option, { selected }) => (
                          <li {...props} style={{ height: "34px" }}>
                            <Checkbox
                              checked={selected}
                              style={{ marginRight: 2 }}
                              color="primary"
                              sx={{
                                "& .MuiSvgIcon-root": {
                                  fontSize: 17,
                                },
                                color: "#94a3b8",
                              }}
                            />
                            {option.name}
                          </li>
                        )}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Cerbo Tag Condition"
                            size="small"
                            fullWidth
                            variant="outlined"
                            sx={{
                              bgcolor: "#fff",
                              borderRadius: 2,
                              "& .MuiOutlinedInput-root": {
                                fontSize: 14,
                                color: "#23244A",
                                borderRadius: 2,
                                "& fieldset": {
                                  borderColor: "#dedede",
                                },
                                "&:hover fieldset": {
                                  borderColor: "#3D52A0",
                                },
                                "&.Mui-focused fieldset": {
                                  borderColor: "#3D52A0",
                                },
                              },

                              "& .MuiInputLabel-root": {
                                fontSize: 13,
                                color: "#23244A",
                              },
                            }}
                          />
                        )}
                        sx={{
                          width: "50%",
                          bgcolor: "#fff",
                          borderRadius: 2,
                          boxShadow: "0 2px 8px rgba(24,26,42,0.08)",
                        }}
                      />
                    </Grid>
                  </>
                )}
              </Grid>
            </Box>
          </Box>

          <Box sx={{ display: "flex", gap: 1, position: "relative" }}>
            <Box className="step-number">3</Box>
            <Box
              sx={{
                position: "absolute",
                left: 19,
                top: 38,
                bottom: 0,
                width: 2,
                bgcolor: "#e2e8f0",
              }}
            />
            <Box sx={{ width: "100%" }}>
              <Box
                sx={{
                  bgcolor: "#f3f9ff",
                  px: 2,
                  py: 1,
                  borderRadius: 4,
                }}
              >
                <Typography
                  variant="subtitle1"
                  sx={{ fontWeight: 600, fontSize: 14 }}
                >
                  HL Tag Name
                </Typography>
                <Typography sx={{ fontSize: 11, color: "#555" }}>
                  Enter the HL tag name associated with this
                  questionnaire.
                </Typography>
              </Box>

              <Grid
                container
                spacing={2}
                direction="column"
                sx={{ mt: 3, mb: 4, ml: 3 }}
              >
                <Grid>
                  <Autocomplete
                    multiple
                    disableCloseOnSelect
                    fullWidth
                    limitTags={2} // Show up to 2 tags, then "+N"
                    options={props.TagList}
                    getOptionLabel={(option) => option.name}
                    slotProps={{
                      paper: {
                        sx: {
                          "& .MuiAutocomplete-option": {
                            fontSize: 13,
                            minHeight: 32,
                          },
                        },
                      },
                    }}
                    value={
                      props.TagList.filter((tag) =>
                        AddCrmTagIds.includes(tag.id),
                      ) || []
                    }
                    onChange={(_, newValue) => {
                      setAddCrmTagIds(
                        newValue ? newValue.map((tag) => tag.id) : [],
                      );
                    }}
                    renderOption={(props, option, { selected }) => (
                      <li {...props} style={{ height: "34px" }}>
                        <Checkbox
                          checked={selected}
                          style={{ marginRight: 2 }}
                          color="primary"
                          sx={{
                            "& .MuiSvgIcon-root": {
                              fontSize: 17,
                            },
                            color: "#94a3b8",
                          }}
                        />
                        {option.name}
                      </li>
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="HL Add Tag"
                        size="small"
                        variant="outlined"
                        sx={{
                          bgcolor: "#fff",
                          borderRadius: 2,
                          boxShadow: "0 2px 8px rgba(24,26,42,0.08)",
                          "& .MuiOutlinedInput-root": {
                            fontSize: 14,
                            color: "#23244A",
                            borderRadius: 2,
                            "& fieldset": {
                              borderColor: "#dedede",
                            },
                            "&:hover fieldset": {
                              borderColor: "#3D52A0",
                            },
                            "&.Mui-focused fieldset": {
                              borderColor: "#3D52A0",
                            },
                          },

                          "& .MuiInputLabel-root": {
                            fontSize: 13,
                            color: "#23244A",
                          },
                        }}
                      />
                    )}
                    sx={{
                      width: "50%",
                      bgcolor: "#fff",
                      borderRadius: 2,
                      boxShadow: "0 2px 8px rgba(24,26,42,0.08)",
                    }}
                    disableClearable
                  />
                </Grid>
                <Grid>
                  <Autocomplete
                    multiple
                    disableCloseOnSelect
                    fullWidth
                    limitTags={2} // Show up to 2 tags, then "+N"
                    options={props.TagList}
                    getOptionLabel={(option) => option.name}
                    slotProps={{
                      paper: {
                        sx: {
                          "& .MuiAutocomplete-option": {
                            fontSize: 13,
                            minHeight: 32,
                          },
                        },
                      },
                    }}
                    value={
                      props.TagList.filter((tag) =>
                        RemoveCrmTagIds.includes(tag.id),
                      ) || []
                    }
                    onChange={(_, newValue) => {
                      setRemoveCrmTagIds(
                        newValue ? newValue.map((tag) => tag.id) : [],
                      );
                    }}
                    renderOption={(props, option, { selected }) => (
                      <li {...props} style={{ height: "34px" }}>
                        <Checkbox
                          checked={selected}
                          style={{ marginRight: 2 }}
                          color="primary"
                          sx={{
                            "& .MuiSvgIcon-root": {
                              fontSize: 17,
                            },
                            color: "#94a3b8",
                          }}
                        />
                        {option.name}
                      </li>
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="HL Remove Tag"
                        size="small"
                        variant="outlined"
                        sx={{
                          bgcolor: "#fff",
                          borderRadius: 2,
                          "& .MuiOutlinedInput-root": {
                            fontSize: 14,
                            color: "#23244A",
                            borderRadius: 2,
                            "& fieldset": {
                              borderColor: "#dedede",
                            },
                            "&:hover fieldset": {
                              borderColor: "#3D52A0",
                            },
                            "&.Mui-focused fieldset": {
                              borderColor: "#3D52A0",
                            },
                          },

                          "& .MuiInputLabel-root": {
                            fontSize: 13,
                            color: "#23244A",
                          },
                        }}
                      />
                    )}
                    sx={{
                      width: "50%",
                      bgcolor: "#fff",
                      borderRadius: 2,
                      boxShadow: "0 2px 8px rgba(24,26,42,0.08)",
                    }}
                    disableClearable
                  />
                </Grid>
              </Grid>
            </Box>
          </Box>

          <Box sx={{ display: "flex", gap: 1, position: "relative" }}>
            <Box className="step-number">4</Box>
            <Box
              sx={{
                position: "absolute",
                left: 19,
                top: 38,
                bottom: 0,
                width: 2,
                bgcolor: "#e2e8f0",
              }}
            />
            <Box sx={{ width: "100%" }}>
              <Box
                sx={{
                  bgcolor: "#f3f9ff",
                  px: 2,
                  py: 1,
                  borderRadius: 4,
                }}
              >
                <Typography
                  variant="subtitle1"
                  sx={{ fontWeight: 600, fontSize: 14 }}
                >
                  Cerbo Tag Name
                </Typography>
                <Typography sx={{ fontSize: 11, color: "#555" }}>
                  Enter the cerbo tag name associated with this questionnaire.
                </Typography>
              </Box>

              <Grid
                container
                spacing={2}
                direction="column"
                sx={{ mt: 3, mb: 4, ml: 3 }}
              >
                <Grid>
                  <Autocomplete
                    multiple
                    disableCloseOnSelect
                    fullWidth
                    limitTags={2} // Show up to 2 tags, then "+N"
                    options={props.cerboTags}
                    getOptionLabel={(option) => option.name}
                    slotProps={{
                      paper: {
                        sx: {
                          "& .MuiAutocomplete-option": {
                            fontSize: 13,
                            minHeight: 32,
                          },
                        },
                      },
                    }}
                    value={
                      props.cerboTags.filter((tag) =>
                        AddcerboTagIds.includes(tag.id),
                      ) || []
                    }
                    onChange={(_, newValue) => {
                      setAddcerboTagIds(
                        newValue ? newValue.map((tag) => tag.id) : [],
                      );
                    }}
                    renderOption={(props, option, { selected }) => (
                      <li {...props} style={{ height: "34px" }}>
                        <Checkbox
                          checked={selected}
                          style={{ marginRight: 2 }}
                          color="primary"
                          sx={{
                            "& .MuiSvgIcon-root": {
                              fontSize: 17,
                            },
                            color: "#94a3b8",
                          }}
                        />
                        {option.name}
                      </li>
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Cerbo Add Tag"
                        size="small"
                        variant="outlined"
                        sx={{
                          bgcolor: "#fff",
                          borderRadius: 2,
                          "& .MuiOutlinedInput-root": {
                            fontSize: 14,
                            color: "#23244A",
                            borderRadius: 2,
                            "& fieldset": {
                              borderColor: "#dedede",
                            },
                            "&:hover fieldset": {
                              borderColor: "#3D52A0",
                            },
                            "&.Mui-focused fieldset": {
                              borderColor: "#3D52A0",
                            },
                          },

                          "& .MuiInputLabel-root": {
                            fontSize: 13,
                            color: "#23244A",
                          },
                        }}
                      />
                    )}
                    sx={{
                      width: "50%",
                      bgcolor: "#fff",
                      borderRadius: 2,
                      boxShadow: "0 2px 8px rgba(24,26,42,0.08)",
                    }}
                    disableClearable
                  />
                </Grid>
                <Grid>
                  <Autocomplete
                    multiple
                    disableCloseOnSelect
                    fullWidth
                    limitTags={2} // Show up to 2 tags, then "+N"
                    options={props.cerboTags}
                    getOptionLabel={(option) => option.name}
                    slotProps={{
                      paper: {
                        sx: {
                          "& .MuiAutocomplete-option": {
                            fontSize: 13,
                            minHeight: 32,
                          },
                        },
                      },
                    }}
                    value={
                      props.cerboTags.filter((tag) =>
                        RemovecerboTagIds.includes(tag.id),
                      ) || []
                    }
                    onChange={(_, newValue) => {
                      setRemovecerboTagIds(
                        newValue ? newValue.map((tag) => tag.id) : [],
                      );
                    }}
                    renderOption={(props, option, { selected }) => (
                      <li {...props} style={{ height: "34px" }}>
                        <Checkbox
                          checked={selected}
                          style={{ marginRight: 2 }}
                          color="primary"
                          sx={{
                            "& .MuiSvgIcon-root": {
                              fontSize: 17,
                            },
                            color: "#94a3b8",
                          }}
                        />
                        {option.name}
                      </li>
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Cerbo Remove Tag"
                        size="small"
                        variant="outlined"
                        sx={{
                          bgcolor: "#fff",
                          borderRadius: 2,
                          boxShadow: "0 2px 8px rgba(24,26,42,0.08)",
                          "& .MuiOutlinedInput-root": {
                            fontSize: 14,
                            color: "#23244A",
                            borderRadius: 2,
                            "& fieldset": {
                              borderColor: "#dedede",
                            },
                            "&:hover fieldset": {
                              borderColor: "#3D52A0",
                            },
                            "&.Mui-focused fieldset": {
                              borderColor: "#3D52A0",
                            },
                          },

                          "& .MuiInputLabel-root": {
                            fontSize: 13,
                            color: "#23244A",
                          },
                        }}
                      />
                    )}
                    sx={{
                      width: "50%",
                      bgcolor: "#fff",
                      borderRadius: 2,
                      boxShadow: "0 2px 8px rgba(24,26,42,0.08)",
                    }}
                    disableClearable
                  />
                </Grid>
              </Grid>
            </Box>
          </Box>

          {/* <Box sx={{ display: "flex", gap: 1, position: "relative" }}>
            <Box className="step-number">5</Box>
            <Box sx={{ width: "100%" }}>
              <Box
                sx={{
                  bgcolor: "#f3f9ff",
                  px: 2,
                  py: 1,
                  borderRadius: 4,
                }}
              >
                <Typography
                  variant="subtitle1"
                  sx={{ fontWeight: 600, fontSize: 14 }}
                >
                  Custom Field (Optional)
                </Typography>
                <Typography sx={{ fontSize: 11, color: "#555" }}>
                  Enable and select a custom field with a value for this
                  questionnaire.
                </Typography>
              </Box>

              <Grid
                container
                spacing={2}
                direction="column"
                sx={{ mt: 2, mb: 4, ml: 3 }}
              >
                <Grid>
                  <FormControlLabel
                    sx={{
                      "& .MuiFormControlLabel-label": {
                        fontSize: 13,
                        color: "#475569",
                      },
                    }}
                    control={
                      <Checkbox
                        checked={enableCustomField}
                        style={{ marginRight: 2 }}
                        onChange={(e) =>
                          setEnableCustomField(e.target.checked)
                        }
                        sx={{
                          "& .MuiSvgIcon-root": {
                            fontSize: 18,
                          },
                          color: "#94a3b8",
                        }}
                      />
                    }
                    label="Enable Custom Field"
                  />
                </Grid>

                {enableCustomField && (
                  <>
                    <Grid
                      container
                      spacing={2}
                      direction="row"
                      alignItems="flex-start"
                    >
                      <Grid sx={{ flex: 1, minWidth: 0 }}>
                        <Autocomplete
                          fullWidth
                          options={props.customFields || []}
                          getOptionLabel={(option) => option.fieldName}
                          slotProps={{
                            paper: {
                              sx: {
                                "& .MuiAutocomplete-option": {
                                  fontSize: 13,
                                  minHeight: 32,
                                },
                              },
                            },
                          }}
                          value={
                            props.customFields?.find(
                              (f) => f.fieldId === customFieldId,
                            ) || undefined
                          }
                          onChange={(_, newValue) =>
                            setCustomFieldId(
                              newValue ? newValue.fieldId : "",
                            )
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Custom Field"
                              size="small"
                              fullWidth
                              variant="outlined"
                              sx={{
                                bgcolor: "#fff",
                                borderRadius: 2,
                                "& .MuiOutlinedInput-root": {
                                  fontSize: 14,
                                  color: "#23244A",
                                  borderRadius: 2,
                                  "& fieldset": {
                                    borderColor: "#dedede",
                                  },
                                  "&:hover fieldset": {
                                    borderColor: "#3D52A0",
                                  },
                                  "&.Mui-focused fieldset": {
                                    borderColor: "#3D52A0",
                                  },
                                },
                                "& .MuiInputLabel-root": {
                                  fontSize: 13,
                                  color: "#23244A",
                                },
                              }}
                            />
                          )}
                          sx={{
                            bgcolor: "#fff",
                            borderRadius: 2,
                            boxShadow:
                              "0 2px 8px rgba(24,26,42,0.08)",
                          }}
                          disableClearable
                        />
                      </Grid>
                      <Grid sx={{ flex: 1, minWidth: 0 }}>
                        <TextField
                          label="Custom Field Value"
                          value={customFieldValue}
                          onChange={(e) =>
                            setCustomFieldValue(e.target.value)
                          }
                          fullWidth
                          size="small"
                          variant="outlined"
                          sx={{
                            bgcolor: "#fff",
                            borderRadius: 2,
                            boxShadow:
                              "0 2px 8px rgba(24,26,42,0.08)",
                            "& .MuiOutlinedInput-root": {
                              fontSize: 14,
                              color: "#23244A",
                              borderRadius: 2,
                              "& fieldset": {
                                borderColor: "#dedede",
                              },
                              "&:hover fieldset": {
                                borderColor: "#3D52A0",
                              },
                              "&.Mui-focused fieldset": {
                                borderColor: "#3D52A0",
                              },
                            },
                            "& .MuiInputLabel-root": {
                              fontSize: 13,
                              color: "#23244A",
                            },
                          }}
                        />
                      </Grid>
                    </Grid>

                    <Grid
                      container
                      spacing={2}
                      direction="row"
                      alignItems="flex-start"
                      sx={{ mt: 0 }}
                    >
                      <Grid sx={{ flex: 1, minWidth: 0 }}>
                        <Autocomplete
                          fullWidth
                          options={props.cerboTags || []}
                          getOptionLabel={(option) => option.name}
                          slotProps={{
                            paper: {
                              sx: {
                                "& .MuiAutocomplete-option": {
                                  fontSize: 13,
                                  minHeight: 32,
                                },
                              },
                            },
                          }}
                          value={
                            props.cerboTags?.find(
                              (t) => t.id === cerboTagEntityId,
                            ) || undefined
                          }
                          onChange={(_, newValue) =>
                            setCerboTagEntityId(
                              newValue ? newValue.id : "",
                            )
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Cerbo Tag"
                              size="small"
                              fullWidth
                              variant="outlined"
                              sx={{
                                bgcolor: "#fff",
                                borderRadius: 2,
                                "& .MuiOutlinedInput-root": {
                                  fontSize: 14,
                                  color: "#23244A",
                                  borderRadius: 2,
                                  "& fieldset": {
                                    borderColor: "#dedede",
                                  },
                                  "&:hover fieldset": {
                                    borderColor: "#3D52A0",
                                  },
                                  "&.Mui-focused fieldset": {
                                    borderColor: "#3D52A0",
                                  },
                                },
                                "& .MuiInputLabel-root": {
                                  fontSize: 13,
                                  color: "#23244A",
                                },
                              }}
                            />
                          )}
                          sx={{
                            bgcolor: "#fff",
                            borderRadius: 2,
                            boxShadow:
                              "0 2px 8px rgba(24,26,42,0.08)",
                          }}
                          disableClearable
                        />
                      </Grid>
                      <Grid sx={{ flex: 1, minWidth: 0 }}>
                        <TextField
                          label="Cerbo Tag Value"
                          value={cerboTagEntityValue}
                          onChange={(e) =>
                            setCerboTagEntityValue(e.target.value)
                          }
                          fullWidth
                          size="small"
                          variant="outlined"
                          sx={{
                            bgcolor: "#fff",
                            borderRadius: 2,
                            boxShadow:
                              "0 2px 8px rgba(24,26,42,0.08)",
                            "& .MuiOutlinedInput-root": {
                              fontSize: 14,
                              color: "#23244A",
                              borderRadius: 2,
                              "& fieldset": {
                                borderColor: "#dedede",
                              },
                              "&:hover fieldset": {
                                borderColor: "#3D52A0",
                              },
                              "&.Mui-focused fieldset": {
                                borderColor: "#3D52A0",
                              },
                            },
                            "& .MuiInputLabel-root": {
                              fontSize: 13,
                              color: "#23244A",
                            },
                          }}
                        />
                      </Grid>
                    </Grid>


                  </>
                )}
              </Grid>
            </Box>
          </Box> */}

          {/* Step 5: Custom Field Selection */}
          <Box sx={{ display: "flex", gap: 1, position: "relative" }}>
            <Box className="step-number">5</Box>
            <Box
              sx={{
                position: "absolute",
                left: 19,
                top: 38,
                bottom: 0,
                width: 2,
                bgcolor: "#e2e8f0",
              }}
            />
            <Box sx={{ width: "100%" }}>
              <Box
                sx={{
                  bgcolor: "#f3f9ff",
                  px: 2,
                  py: 1,
                  borderRadius: 4,
                }}
              >
                <Grid direction='row' container alignItems="center" gap={0.5}>
                  <Typography
                    variant="subtitle1"
                    sx={{ fontWeight: 600, fontSize: 14 }}
                  >
                    Custom Field
                  </Typography>
                  <span style={{ fontWeight: 600, color: '#888' }}>(Optional)</span>
                </Grid>
                <Typography sx={{ fontSize: 11, color: "#555" }}>
                  Select a custom field and provide its value.
                </Typography>
              </Box>

              <Grid
                container
                spacing={2}
                direction="column"
                sx={{ mt: 2, mb: 4, ml: 3 }}
              >
                <Grid
                  container
                  spacing={2}
                  direction="row"
                  alignItems="flex-start"
                >
                  <Grid sx={{ flex: 1, minWidth: 0 }}>
                    <Autocomplete
                      fullWidth
                      options={props.customFields || []}
                      getOptionLabel={(option) => option.fieldName}
                      slotProps={{
                        paper: {
                          sx: {
                            "& .MuiAutocomplete-option": {
                              fontSize: 13,
                              minHeight: 32,
                            },
                          },
                        },
                      }}
                      value={
                        props.customFields?.find(
                          (f) => f.fieldId === customFieldId,
                        ) || undefined
                      }
                      onChange={(_, newValue) =>
                        setCustomFieldId(
                          newValue ? newValue.fieldId : "",
                        )
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Custom Field"
                          size="small"
                          fullWidth
                          variant="outlined"
                          sx={{
                            bgcolor: "#fff",
                            borderRadius: 2,
                            "& .MuiOutlinedInput-root": {
                              fontSize: 14,
                              color: "#23244A",
                              borderRadius: 2,
                              "& fieldset": {
                                borderColor: "#dedede",
                              },
                              "&:hover fieldset": {
                                borderColor: "#3D52A0",
                              },
                              "&.Mui-focused fieldset": {
                                borderColor: "#3D52A0",
                              },
                            },
                            "& .MuiInputLabel-root": {
                              fontSize: 13,
                              color: "#23244A",
                            },
                          }}
                        />
                      )}
                      sx={{
                        bgcolor: "#fff",
                        borderRadius: 2,
                        boxShadow:
                          "0 2px 8px rgba(24,26,42,0.08)",
                      }}
                    />
                  </Grid>
                  <Grid sx={{ flex: 1, minWidth: 0 }}>
                    <TextField
                      label="Custom Field Value"
                      value={customFieldValue}
                      onChange={(e) =>
                        setCustomFieldValue(e.target.value)
                      }
                      fullWidth
                      size="small"
                      variant="outlined"
                      sx={{
                        bgcolor: "#fff",
                        borderRadius: 2,
                        boxShadow:
                          "0 2px 8px rgba(24,26,42,0.08)",
                        "& .MuiOutlinedInput-root": {
                          fontSize: 14,
                          color: "#23244A",
                          borderRadius: 2,
                          "& fieldset": {
                            borderColor: "#dedede",
                          },
                          "&:hover fieldset": {
                            borderColor: "#3D52A0",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "#3D52A0",
                          },
                        },
                        "& .MuiInputLabel-root": {
                          fontSize: 13,
                          color: "#23244A",
                        },
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Box>
          </Box>

          {/* Step 6: Cerbo Notes Tag */}
          <Box sx={{ display: "flex", gap: 1, position: "relative" }}>
            <Box className="step-number">6</Box>
            <Box sx={{ width: "100%" }}>
              <Box
                sx={{
                  bgcolor: "#f3f9ff",
                  px: 2,
                  py: 1,
                  borderRadius: 4,
                }}
              >
                <Grid direction='row' container alignItems="center" gap={0.5}>
                  <Typography
                    variant="subtitle1"
                    sx={{ fontWeight: 600, fontSize: 14 }}
                  >
                    Cerbo Notes Tag
                  </Typography>
                  <span style={{ fontWeight: 600, color: '#888' }}>(Optional)</span>
                </Grid>
                <Typography sx={{ fontSize: 11, color: "#555" }}>
                  Select a Cerbo tag for notes and provide notes content.
                </Typography>
              </Box>

              <Grid
                container
                spacing={2}
                direction="column"
                sx={{ mt: 2, mb: 4, ml: 3 }}
              >
                <Grid
                  container
                  spacing={2}
                  direction="row"
                  alignItems="flex-start"
                >
                  <Grid sx={{ flex: 1, minWidth: 0 }}>
                    <Autocomplete
                      fullWidth
                      options={props.tagListForNotes || []}
                      getOptionLabel={(option) => option.name}
                      slotProps={{
                        paper: {
                          sx: {
                            "& .MuiAutocomplete-option": {
                              fontSize: 13,
                              minHeight: 32,
                            },
                          },
                        },
                      }}
                      value={
                        props.tagListForNotes?.find(
                          (t) => t.id === cerboNotesTagId,
                        ) || undefined
                      }
                      onChange={(_, newValue) =>
                        setCerboNotesTagId(
                          newValue ? newValue.id : "",
                        )
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Cerbo Notes Tag"
                          size="small"
                          fullWidth
                          variant="outlined"
                          sx={{
                            bgcolor: "#fff",
                            borderRadius: 2,
                            "& .MuiOutlinedInput-root": {
                              fontSize: 14,
                              color: "#23244A",
                              borderRadius: 2,
                              "& fieldset": {
                                borderColor: "#dedede",
                              },
                              "&:hover fieldset": {
                                borderColor: "#3D52A0",
                              },
                              "&.Mui-focused fieldset": {
                                borderColor: "#3D52A0",
                              },
                            },
                            "& .MuiInputLabel-root": {
                              fontSize: 13,
                              color: "#23244A",
                            },
                          }}
                        />
                      )}
                      sx={{
                        bgcolor: "#fff",
                        borderRadius: 2,
                        boxShadow:
                          "0 2px 8px rgba(24,26,42,0.08)",
                      }}
                    />
                  </Grid>
                  <Grid sx={{ flex: 1, minWidth: 0 }}>
                    <TextField
                      label="Tag Notes"
                      value={cerboTagNotes}
                      onChange={(e) =>
                        setCerboTagNotes(e.target.value)
                      }
                      fullWidth
                      size="small"
                      variant="outlined"
                      sx={{
                        bgcolor: "#fff",
                        borderRadius: 2,
                        boxShadow:
                          "0 2px 8px rgba(24,26,42,0.08)",
                        "& .MuiOutlinedInput-root": {
                          fontSize: 14,
                          color: "#23244A",
                          borderRadius: 2,
                          "& fieldset": {
                            borderColor: "#dedede",
                          },
                          "&:hover fieldset": {
                            borderColor: "#3D52A0",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "#3D52A0",
                          },
                        },
                        "& .MuiInputLabel-root": {
                          fontSize: 13,
                          color: "#23244A",
                        },
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Box>
          </Box>
        </Box>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2, pt: 2, background: "#FAFAFC" }}>
        <Button
          variant="outlined"
          color="secondary"
          onClick={handleCancel}
          sx={{
            borderRadius: 2,
            fontWeight: 500,
            minWidth: 110,
            border: "none",
            background: "#dedede",
            color: "#000",
            textTransform: "capitalize",
            "&:hover": { background: "#d6d6d6" },
          }}
        >
          Cancel
        </Button>
        <Button
          type="submit"
          variant="contained"
          color="primary"
          disabled={saving || !enableSave}
          onClick={handleSubmit}
          sx={{
            borderRadius: 2,
            fontWeight: 500,
            minWidth: 160,
            background: "#1eac53",
            textTransform: "capitalize",
            "&:hover": { background: "#1a9849" },
          }}
        >
          {saving ? "Saving..." : "Save & Continue"}
        </Button>
      </DialogActions>
      {error && (
        <Box
          sx={{
            color: "#d32f2f",
            textAlign: "center",
            pb: 2,
            px: 3,
            fontWeight: 500,
          }}
        >
          {error}
        </Box>
      )}
    </Dialog>
  );
};

export default AddQuestionnaire;
